import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import CookieConsent from "react-cookie-consent";
import { initializeAnalytics } from "./analytics";

initializeAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="containerApp">
      <App />
      <CookieConsent>This website uses cookies to enhance the user experience.</CookieConsent>
    </div>
  </React.StrictMode>
);